import React, { useEffect } from "react";
import {
  withSitecoreContext,
  Placeholder,
  RichText,
  ComponentRendering,
} from "@sitecore-jss/sitecore-jss-react";

import "./index.scss";
import { CollapsibleTextModuleModel } from "./models/CollapsibleTextModule.model";
import { CollapsibleTextModuleProps } from "./types/CollapsibleTextModule.types";

const CollapsibleTextModule = (props: CollapsibleTextModuleProps) => {
  const model = new CollapsibleTextModuleModel(props);
  const [isOpen, setOpen] = React.useState(false);
  const [isExtendedText, setCollapsedText] = React.useState(false);

  if (typeof window !== "undefined" && typeof document !== "undefined") {
    const queryParameters = new URLSearchParams(window.location.search)
    const type = queryParameters.get("open");

    useEffect(() => {
      // const getHashId = document.querySelector(`${window.location.hash} .privacy-collapsible-title`) as HTMLElement;

      if (type === "all") {
        setOpen(!isOpen);
      } else if (type === "first" && (typeof document !== 'undefined')) {
        const firstElement = document.querySelector(".privacy-collapsible-title") as HTMLElement;
        firstElement.click();
      }

      // getHashId.click();
    }, [])
  }

  return (
    <>
      {props?.fields && (
        <div id={`${model?.anchorID?.value}`} className="privacy-collapsible-module">
          <div className={`privacy-collapsible-title ${isOpen ? "open" : ""}`} onClick={() => setOpen(!isOpen)}>
            {model?.title?.value}
            <span className="accordion-plus-icon"></span>
          </div>
          <div className={`privacy-collapsible-text ${isOpen ? "open" : ""}`}>
            <div className="collapsible-primary-text">
              <RichText field={model?.primaryText} />
            </div>
            <div className={`collapsible-secondary-text  ${isExtendedText ? "extended" : ""}`} >
              <RichText field={model?.secondaryText} />
              <Placeholder name="jss-privacyhub" rendering={props?.rendering as ComponentRendering} />
            </div>
            <div className="policy-read-more" onClick={() => setCollapsedText(!isExtendedText)}>
              {model?.learnMoreLabel?.value}
            </div>
          </div>
        </div>
      )}
    </>

  );
};

export default withSitecoreContext()(CollapsibleTextModule);
